import {ControllerParams} from '@wix/yoshi-flow-editor';
import {getFormattingLanguage} from './getFormattingLanguage';

export function getFormattingFunction({
  flowAPI,
  formatingCurrency,
}: {
  flowAPI: ControllerParams['flowAPI'];
  formatingCurrency: string;
}) {
  const createCurrencyFormatter = flowAPI.essentials.createCurrencyFormatterWithDefaults({
    language: getFormattingLanguage(flowAPI),
  });
  const formatCurrency = createCurrencyFormatter();
  return (amount: string | number) => formatCurrency({value: amount, currency: formatingCurrency || 'USD'});
}
